import React, {useEffect, VoidFunctionComponent} from "react";
import Utils from "@/libs/Utils";

export const Target2SellBloc: VoidFunctionComponent<{ pID: string, espaceID: string, iID: string }> = ({
                                                                                                           pID,
                                                                                                           espaceID,
                                                                                                           iID
                                                                                                       }) => {

    useEffect(() => {
        Utils.recoT2S(pID, iID)
    }, []);
    
    return (
        <div className="target2sell" id={`PPNA1QL127P68J-${pID}-${espaceID}`}/>
    );
};